import React from "react";

type ContainerProps = {
  children: React.ReactNode;
  className?: string;
};

const Container = ({ children, className = "" }: ContainerProps) => {
  return (
    <div 
      className={`px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 2xl:px-24 mx-auto w-full ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;